//Third parties
import { AnimeParams } from "animejs";

export const animeJSBaseParams: Partial<AnimeParams> = {
  duration: 500, //500ms for animation duration
  easing: "cubicBezier(.295, .815, .425, .945)", //Easing
};

export const carouselAutoplay = 6000;
